// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-tournament-page {
  min-height: 100vh;
  background-color: #f8fafc;
  color: #1e293b;
}

.edit-tournament-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 20px 0;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.header-content {
  max-width: 1600px;
  margin: 0 auto;
  padding: 0;
  display: flex;
  align-items: center;
  text-align: center;
}

.tournament-info h1 {
  margin: 0 0 8px 0;
  font-size: 28px;
  font-weight: 600;
}

.tournament-meta {
  display: flex;
  align-items: center;
  gap: 12px;
}

.status-badge {
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-draft {
  background-color: var(--status-draft, #ffc107);
  color: #212529;
}

.status-active {
  background-color: var(--status-active, #28a745);
  color: white;
}

.status-live {
  background-color: var(--status-live, #dc3545);
  color: white;
}

.status-completed {
  background-color: var(--status-completed, #6c757d);
  color: white;
}

.status-cancelled {
  background-color: var(--status-cancelled, #dc3545);
  color: white;
}

/* Leaderboard Management Styles */
.leaderboard-section {
  margin-top: 20px;
  padding: 16px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.leaderboard-section h4 {
  margin: 0 0 8px 0;
  color: #495057;
  font-size: 16px;
  font-weight: 600;
}

.leaderboard-section p {
  margin: 0 0 12px 0;
  color: #6c757d;
  font-size: 14px;
  line-height: 1.4;
}

.init-leaderboard-btn {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.init-leaderboard-btn:hover:not(:disabled) {
  background-color: #0056b3;
}

.init-leaderboard-btn:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

.modification-warning {
  font-size: 12px;
  background-color: rgba(255, 193, 7, 0.2);
  color: #fff3cd;
  padding: 4px 8px;
  border-radius: 4px;
  border: 1px solid rgba(255, 193, 7, 0.3);
}

.unsaved-changes {
  background-color: rgba(255, 87, 51, 0.2);
  color: #ffcccb;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  border: 1px solid rgba(255, 87, 51, 0.3);
}

.edit-tournament-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 30px 20px;
}

.tournament-tabs {
  display: flex;
  background: white;
  border-radius: 12px 12px 0 0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  margin-bottom: 0;
  border: 1px solid #e2e8f0;
  border-bottom: none;
}

.edit-tournament-tab-button {
  flex: 1 1;
  background: none;
  border: none;
  padding: 18px 20px;
  cursor: pointer;
  font-size: 15px;
  font-weight: 500;
  color: #64748b;
  border-bottom: 3px solid transparent;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  position: relative;
}

.edit-tournament-tab-button:hover:not(.active) {
  background-color: #f1f5f9;
  color: #374151;
}

.edit-tournament-tab-button.active {
  color: #2563eb;
  border-bottom-color: #2563eb;
  background-color: #f1f5f9;
  font-weight: 600;
}

.tab-icon {
  font-size: 16px;
}

.tab-label {
  font-weight: 600;
}

.tab-count {
  background-color: #e5e7eb;
  color: #6b7280;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  margin-left: 8px;
  min-width: 20px;
  text-align: center;
  transition: all 0.3s ease;
}

.edit-tournament-tab-button.active .tab-count {
  background-color: white;
  color: #2563eb;
  font-weight: 700;
}

.tab-content {
  background: white;
  border-radius: 0 0 12px 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  min-height: 600px;
  border: 1px solid var(--border-primary, #e2e8f0);
}

/* Loading and error states */
.edit-tournament-loading,
.tournament-not-found,
.access-denied {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 20px;
}

/* Edit Tournament loading spinner */
.edit-tournament-loading-spinner {
  font-size: 18px;
  color: #6c757d;
  text-align: center;
}

.edit-tournament-spinner {
  width: 2rem;
  height: 2rem;
  border: 3px solid var(--border-primary, #e2e8f0);
  border-top: 3px solid var(--primary, #667eea);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 1rem;
}

/* Responsive design */
@media (max-width: 768px) {
  .header-content {
    text-align: center;
  }

  .tournament-info h1 {
    font-size: 24px;
  }

  .tournament-tabs {
    flex-direction: column;
  }

  .tab-button {
    justify-content: flex-start;
    padding: 15px 20px;
  }

  .edit-tournament-content {
    padding: 20px 15px;
  }
}

@media (max-width: 480px) {
  .tournament-meta {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .modification-warning {
    font-size: 11px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/EditTournament.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,8CAA8C;EAC9C,cAAc;AAChB;;AAEA;EACE,+CAA+C;EAC/C,YAAY;AACd;;AAEA;EACE,6CAA6C;EAC7C,YAAY;AACd;;AAEA;EACE,kDAAkD;EAClD,YAAY;AACd;;AAEA;EACE,kDAAkD;EAClD,YAAY;AACd;;AAEA,kCAAkC;AAClC;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,wCAAwC;EACxC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,4BAA4B;EAC5B,wCAAwC;EACxC,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,wCAAwC;EACxC,iBAAiB;EACjB,gDAAgD;AAClD;;AAEA,6BAA6B;AAC7B;;;EAGE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;AACf;;AAEA,oCAAoC;AACpC;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gDAAgD;EAChD,6CAA6C;EAC7C,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,2BAA2B;IAC3B,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".edit-tournament-page {\n  min-height: 100vh;\n  background-color: #f8fafc;\n  color: #1e293b;\n}\n\n.edit-tournament-header {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 20px 0;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n}\n\n.header-content {\n  max-width: 1600px;\n  margin: 0 auto;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  text-align: center;\n}\n\n.tournament-info h1 {\n  margin: 0 0 8px 0;\n  font-size: 28px;\n  font-weight: 600;\n}\n\n.tournament-meta {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.status-badge {\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.status-draft {\n  background-color: var(--status-draft, #ffc107);\n  color: #212529;\n}\n\n.status-active {\n  background-color: var(--status-active, #28a745);\n  color: white;\n}\n\n.status-live {\n  background-color: var(--status-live, #dc3545);\n  color: white;\n}\n\n.status-completed {\n  background-color: var(--status-completed, #6c757d);\n  color: white;\n}\n\n.status-cancelled {\n  background-color: var(--status-cancelled, #dc3545);\n  color: white;\n}\n\n/* Leaderboard Management Styles */\n.leaderboard-section {\n  margin-top: 20px;\n  padding: 16px;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  border: 1px solid #e9ecef;\n}\n\n.leaderboard-section h4 {\n  margin: 0 0 8px 0;\n  color: #495057;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.leaderboard-section p {\n  margin: 0 0 12px 0;\n  color: #6c757d;\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n.init-leaderboard-btn {\n  background-color: #007bff;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.init-leaderboard-btn:hover:not(:disabled) {\n  background-color: #0056b3;\n}\n\n.init-leaderboard-btn:disabled {\n  background-color: #6c757d;\n  cursor: not-allowed;\n}\n\n.modification-warning {\n  font-size: 12px;\n  background-color: rgba(255, 193, 7, 0.2);\n  color: #fff3cd;\n  padding: 4px 8px;\n  border-radius: 4px;\n  border: 1px solid rgba(255, 193, 7, 0.3);\n}\n\n.unsaved-changes {\n  background-color: rgba(255, 87, 51, 0.2);\n  color: #ffcccb;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  border: 1px solid rgba(255, 87, 51, 0.3);\n}\n\n.edit-tournament-content {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 30px 20px;\n}\n\n.tournament-tabs {\n  display: flex;\n  background: white;\n  border-radius: 12px 12px 0 0;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  margin-bottom: 0;\n  border: 1px solid #e2e8f0;\n  border-bottom: none;\n}\n\n.edit-tournament-tab-button {\n  flex: 1;\n  background: none;\n  border: none;\n  padding: 18px 20px;\n  cursor: pointer;\n  font-size: 15px;\n  font-weight: 500;\n  color: #64748b;\n  border-bottom: 3px solid transparent;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  position: relative;\n}\n\n.edit-tournament-tab-button:hover:not(.active) {\n  background-color: #f1f5f9;\n  color: #374151;\n}\n\n.edit-tournament-tab-button.active {\n  color: #2563eb;\n  border-bottom-color: #2563eb;\n  background-color: #f1f5f9;\n  font-weight: 600;\n}\n\n.tab-icon {\n  font-size: 16px;\n}\n\n.tab-label {\n  font-weight: 600;\n}\n\n.tab-count {\n  background-color: #e5e7eb;\n  color: #6b7280;\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 600;\n  margin-left: 8px;\n  min-width: 20px;\n  text-align: center;\n  transition: all 0.3s ease;\n}\n\n.edit-tournament-tab-button.active .tab-count {\n  background-color: white;\n  color: #2563eb;\n  font-weight: 700;\n}\n\n.tab-content {\n  background: white;\n  border-radius: 0 0 12px 12px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  min-height: 600px;\n  border: 1px solid var(--border-primary, #e2e8f0);\n}\n\n/* Loading and error states */\n.edit-tournament-loading,\n.tournament-not-found,\n.access-denied {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  padding: 20px;\n}\n\n/* Edit Tournament loading spinner */\n.edit-tournament-loading-spinner {\n  font-size: 18px;\n  color: #6c757d;\n  text-align: center;\n}\n\n.edit-tournament-spinner {\n  width: 2rem;\n  height: 2rem;\n  border: 3px solid var(--border-primary, #e2e8f0);\n  border-top: 3px solid var(--primary, #667eea);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin: 0 auto 1rem;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .header-content {\n    text-align: center;\n  }\n\n  .tournament-info h1 {\n    font-size: 24px;\n  }\n\n  .tournament-tabs {\n    flex-direction: column;\n  }\n\n  .tab-button {\n    justify-content: flex-start;\n    padding: 15px 20px;\n  }\n\n  .edit-tournament-content {\n    padding: 20px 15px;\n  }\n}\n\n@media (max-width: 480px) {\n  .tournament-meta {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n\n  .modification-warning {\n    font-size: 11px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
